import type { AssetStatus, AssetType, BrandEntity, PermissionType } from '../../types/assetRegistry';

const badge = (bg: string, color: string, text: string) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', padding: '2px 8px',
    borderRadius: 4, fontSize: 11, fontWeight: 600, background: bg, color,
    lineHeight: 1.6, whiteSpace: 'nowrap',
  }}>{text}</span>
);

export function StatusBadge({ status }: { status: AssetStatus }) {
  const map: Record<AssetStatus, [string, string]> = {
    draft:    ['#f3f4f6', '#374151'],
    approved: ['#d1fae5', '#065f46'],
    archived: ['#fef3c7', '#92400e'],
  };
  return badge(map[status][0], map[status][1], status);
}

export function AssetTypeBadge({ type }: { type: AssetType | null }) {
  if (!type) return null;
  const map: Record<AssetType, [string, string, string]> = {
    image:           ['#e0f2fe', '#075985', 'Image'],
    video:           ['#ede9fe', '#5b21b6', 'Video'],
    copy:            ['#ccfbf1', '#115e59', 'Copy'],
    email_template:  ['#ffedd5', '#9a3412', 'Email'],
    podcast:         ['#fce7f3', '#9d174d', 'Podcast'],
    training_module: ['#cffafe', '#155e75', 'Training'],
  };
  return badge(map[type][0], map[type][1], map[type][2]);
}

export function BrandBadge({ brand }: { brand: BrandEntity | null }) {
  if (!brand) return null;
  const map: Record<BrandEntity, [string, string, string]> = {
    carebrave:     ['#dbeafe', '#1e40af', 'CareBravo'],
    carepreneur:   ['#e0e7ff', '#3730a3', 'Carepreneur'],
    karavista:     ['#ffe4e6', '#9f1239', 'Karavista'],
    carebinge:     ['#ecfccb', '#3f6212', 'CareBinge'],
    anand_personal:['#f5f5f4', '#44403c', 'Anand'],
    cba_materials: ['#fef9c3', '#92400e', 'CBA'],
  };
  return badge(map[brand][0], map[brand][1], map[brand][2]);
}

export function PermissionBadge({ type }: { type: PermissionType | null }) {
  if (!type) return badge('#f3f4f6', '#9ca3af', 'not set');
  const map: Record<PermissionType, [string, string]> = {
    approved:   ['#d1fae5', '#065f46'],
    exclusive:  ['#fef3c7', '#92400e'],
    restricted: ['#fee2e2', '#991b1b'],
  };
  return badge(map[type][0], map[type][1], type);
}
